/**
 * Editorial design system — the shared "Brief No. 01" language used by the
 * MLX one-pager, the Audere proposal, and (in progress) the marketing
 * homepages. Self-contained palette + semantic colour roles + runtime swatch picker +
 * prop-driven section components.
 */

export * from "./theme";
export * from "./theme-context";
export * from "./theme-switcher";
export * from "./primitives";
export * from "./sections";
export * from "./nav";
export * from "./footer";
export * from "./shell";
export * from "./stat-strip";
export * from "./faq";
export * from "./clients";
export * from "./types";
export * from "./tokens";
export * from "./product-bridge";
